import React, { FC, useEffect, useState } from "react";
import { Flex } from "reflexbox";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import {
  setRolesPageNo,
  // setRolesOrderCriteria,
  // setRolesFilterCriteria,
  fetchRolesList,
} from "./ducks";

import { Text } from "@components/Text";
import { TDispatch, TRootState } from "@redux/types";
import ExpandableRow from "@components/ExpandableRow";
import { useFormatMessage } from "@hooks/formatMessage";
import { Column } from "@components/ExpandableRow/styles";
import { ScrollableList } from "@components/ScrollableList";
import { Filter, Input } from "@icr/react.uicomponents";

import { ReactComponent as IconFilter } from "../../../assets/icons/filter.svg";

const Roles: FC = () => {
  const [filtersOpened, setFiltersOpened] = useState(window.innerWidth >= 1400);
  const [showMoreSpinner, setShowMoreSpinner] = useState(false);
  const [rolesFilter, setRolesFilter] = useState({
    GenericText: null,
  });

  const formatMessage = useFormatMessage();
  const dispatch: TDispatch = useDispatch();

  const { rolesList, moreRoles, rolesPageNo } = useSelector(
    ({ RolesReducer: { roles, moreRoles, rolesPageNo } }: TRootState) => ({
      rolesList: roles,
      moreRoles,
      rolesPageNo,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(fetchRolesList());
  }, [dispatch]);

  const handleLoadMore = () => {
    if (!showMoreSpinner && moreRoles) {
      setShowMoreSpinner(true);
      dispatch(fetchRolesList(rolesPageNo, 10, rolesFilter)).then(() => {
        setShowMoreSpinner(false);
      });
    }
  };

  const changeFilterOpened = () => {
    setFiltersOpened(prevState => !prevState);
  };

  const filterRoles = () => {
    dispatch(setRolesPageNo(1)).then(() => dispatch(fetchRolesList(1, 10, rolesFilter)));
  };

  const clearFilters = () => {
    setRolesFilter({
      GenericText: null,
    });

    dispatch(setRolesPageNo(1)).then(() => dispatch(fetchRolesList(1, 10)));
  };

  return (
    <>
      <Flex pl={["10px", "80px"]} pr={["10px", 0]} height="100%" width="100%">
        <Flex flexDirection="column" width="100%" m="32px 0">
          <ScrollableList
            items={rolesList}
            onLoadMore={handleLoadMore}
            renderHeader={
              <>
                <Column>
                  <Text>{formatMessage("app.username", "Username")}</Text>
                </Column>
                <Column>
                  <Text>{formatMessage("app.role", "Role")}</Text>
                </Column>
                <Column>
                  <Text>{formatMessage("app.application", "Application")}</Text>
                </Column>
                <Column icon>
                  <Text>
                    <div
                      id="toggleFilterArea"
                      className="icon-filter"
                      tabIndex={0}
                      onClick={e => {
                        e.stopPropagation();
                        changeFilterOpened();
                      }}
                    >
                      <IconFilter />
                    </div>
                  </Text>
                </Column>
              </>
            }
            renderItem={(item, index) => (
              <ExpandableRow
                data-cy="userRow"
                key={"userRow" + index}
                id={item.id as string}
                translucent={false}
                expandable={false}
                top={
                  <React.Fragment>
                    <Column>
                      <div className="d-flex flex-row showChildOnHover">
                        <Text light={false} fontSize="16px">
                          {item.username}
                        </Text>
                      </div>
                    </Column>
                    <Column>
                      <div className="d-flex flex-row showChildOnHover">
                        <Text light={false} fontSize="16px">
                          {item.roleName}
                        </Text>
                      </div>
                    </Column>
                    <Column>
                      <div className="d-flex flex-row showChildOnHover">
                        <Text light={false} fontSize="16px">
                          {item.applicationName}
                        </Text>
                      </div>
                    </Column>
                  </React.Fragment>
                }
              />
            )}
          />
        </Flex>
        <Flex>
          <Filter
            id="filterArea"
            open={filtersOpened}
            onClickSearchButton={filterRoles}
            onClickClearButton={clearFilters}
            clearButtonText={formatMessage("app.clear", "Clear")}
            searchButtonText={formatMessage("app.search", "Search")}
          >
            <Input
              id="dynamicSearch"
              label="Dynamic Filter"
              placeholder={formatMessage("app.anyfield", "Any Field")}
              value={rolesFilter.GenericText}
              onChange={e =>
                setRolesFilter(prevState => ({ ...prevState, GenericText: e.target.value }))
              }
            />
          </Filter>
        </Flex>
      </Flex>
    </>
  );
};

export default Roles;
